import { Flex, StackItem, VStack } from '@chakra-ui/react';
import { GlanceAndText, hasAtAGlance } from 'components/combination/glanceAndText';
import { OverviewBlock } from 'components/modules/OverviewBlock';
import { OverviewSpotAutomatic } from 'components/modules/OverviewSpotAutomatic';
import {
  CampaignPageContent,
  CareersAboutPageContent,
  ContentPage as ContentPageModel,
  CustomFormPageContent,
  InsightsPageContent,
  NewsPageContent,
  OfficePageContent,
  OverviewSpotAutomatic as OverviewSpotAutomaticModel,
  OverviewSpotAutomaticNoTabs,
  ProductPageContent,
  ProjectPageContent,
  SectorPageContent,
  ServiceLinePageContent,
  ServicePageContent,
  TextModule as TextModuleModel,
  UnifyingThemePageContent,
} from 'models';
import React, { FC } from 'react';
import { ContentType, mapper } from 'utils/componentMapper';
import Breadcrumb, { BackLink } from '../base/Breadcrumb';
import { hrefLink } from 'utils/normalization/hrefLink';
import { useRouter } from 'next/router';
import { withTranslations } from 'store/translations';

type ContentPageProps = {
  content: ContentPageModel;
};

type LinkedItemType =
  | NewsPageContent
  | SectorPageContent
  | ServiceLinePageContent
  | OfficePageContent
  | ProductPageContent
  | ProjectPageContent
  | ServicePageContent
  | CampaignPageContent
  | InsightsPageContent
  | CustomFormPageContent
  | CareersAboutPageContent
  | UnifyingThemePageContent;
export const ContentPage: FC<ContentPageProps> = ({ content }) => {
  //Special cases in Content Page
  //Used to determine when is the first time Text module shows, to add At A Glance to its side
  const pageContent = (content.elements.content.linkedItems[0] as LinkedItemType)?.elements.pageContent.linkedItems;
  const firstTextModuleIndex = pageContent?.map((element) => element.system.type).indexOf('text');
  const atAGlanceModel = hasAtAGlance(content);
  const router = useRouter();
  const translations = withTranslations();

  const slug = router.query.slug || router.query.mainSubpage || router.query.subcategory;
  const breadcrumbOverride = content.elements.partOfCampaignPage.linkedItems.length
  ? ({
      href: hrefLink(content.elements.partOfCampaignPage.linkedItems[0], slug, true, router.locale, translations),
      label: content.elements.partOfCampaignPage.linkedItems[0].elements.summaryTitle.value,
    } as BackLink)
  : undefined;
  return (
    <>
          {/*---Breadcrumb---*/}
          {!content.elements.hero?.linkedItems.length && breadcrumbOverride != undefined && breadcrumbOverride.href !== '' &&  
          <Flex m={'40px'}><Breadcrumb color='mountain.base' customLink={breadcrumbOverride} /></Flex>
          }  
      {content && (
        <VStack shouldWrapChildren spacing={0}>
    
          {/* --- Hero ---*/}
          {content.elements.hero.linkedItems.map((element, index) => {
            return (
              <StackItem key={index} display='block'>
                {mapper(content.elements.hero.linkedItems[0].system.type as ContentType) &&
                  React.createElement(mapper(content.elements.hero.linkedItems[0].system.type as ContentType) as any, {
                    model: element,
                  })}
              </StackItem>
            );
          })}
          {/* --- Page Content ---*/}
          {pageContent?.map((element, index) => {
            if (!Object.values<string>(ContentType).includes(element.system.type))
              return (
                <StackItem key={index} backgroundColor={'cyan.20'} textStyle={'desktop.h5'} p='s'>
                  Component {element.system.type} is not implemented yet.
                </StackItem>
              );
            const type = element.system.type as ContentType;
            {
              /* At a Glance Condition */
            }
            if (type === ContentType.text && atAGlanceModel && index === firstTextModuleIndex)
              return (
                <StackItem key={index} display='block'>
                  <GlanceAndText textModuleModel={element as TextModuleModel} atAGlanceModel={atAGlanceModel} />
                </StackItem>
              );
            {
              /* Overview Block Condition */
            }
            if (type === ContentType.overview || type === ContentType.overview_spot___automatic) {
              if (type === ContentType.overview) {
                return (
                  <StackItem key={index} display='block'>
                    <OverviewBlock
                      model={element as OverviewSpotAutomaticNoTabs}
                      parentPageCodename={content.system.codename}
                    />
                  </StackItem>
                );
              }
              if (type === ContentType.overview_spot___automatic) {
                return (
                  <StackItem key={index} display='block'>
                    <OverviewSpotAutomatic
                      model={element as OverviewSpotAutomaticModel}
                      parentPageCodename={content.system.codename}
                    />
                  </StackItem>
                );
              }
            }

            return (
              <StackItem key={index} display='block'>
                {mapper(type) && React.createElement(mapper(type) as any, { model: element })}
              </StackItem>
            );
          })}
        </VStack>
      )}
    </>
  );
};
